import { useStoreActions } from '~/contexts';
export function useCreateRelationshipFromDraft() {
    const { api, markHasSentAProposal } = useStoreActions();
    return async (draftId, opts)=>{
        const relationshipId = await api.relationship.createFromDraft(draftId, opts);
        if (relationshipId) {
            markHasSentAProposal(!!(opts === null || opts === void 0 ? void 0 : opts.isSampleRelationship));
        }
        return relationshipId;
    };
}
